'use server';

import { SECTION_MAINTAINER } from '../../api/endpoints';
import request from '../../api/request';
import { actionKitImpFunction } from '../../components/ozmoit/common/action-kit-imp';
import {
  CourseListResponseType,
  FormDataResponseType,
} from '../../types/sectionMaintainerTypes';

export const getContinuousEducationFormDataAction = actionKitImpFunction(
  async () => {
    const response = await request<FormDataResponseType>(
      SECTION_MAINTAINER.GET_CREATE,
    );

    if (response.error) {
      throw new Error(
        response.error.error.message || 'Error loading form data',
      );
    }

    return response.data;
  },
);

export const getContinuousEducationCoursesAction = actionKitImpFunction(
  async ({ schoolId }: { schoolId?: number } = {}) => {
    const faculty = schoolId ? `?schoolId=${schoolId}` : '';
    const response = await request<CourseListResponseType>(
      SECTION_MAINTAINER.COURSES_LIST + faculty,
    );

    if (response.error) {
      throw new Error(response.error.error.message || 'Error loading courses');
    }

    return response.data;
  },
);
